// A dedicated request avoids forwarding Roody authorization headers to object storage.
export function uploadR2File(file, session, { signal, onProgress } = {}) {
  return new Promise((resolve, reject) => {
    if (!session || session.provider !== "cloudflare_r2" || !/^https:\/\//.test(session.uploadUrl || "")) {
      reject(new Error("Der Upload konnte nicht vorbereitet werden."))
      return
    }
    const request = new XMLHttpRequest()
    request.open("PUT", session.uploadUrl, true)
    request.setRequestHeader("Content-Type", session.headers["Content-Type"])
    request.setRequestHeader("If-None-Match", "*")
    const abort = () => request.abort()
    const cleanup = () => signal && signal.removeEventListener("abort", abort)
    request.onload = () => {
      cleanup()
      // A retry may encounter the immutable object from an earlier successful PUT.
      // The backend still verifies its exact size/type before attaching it.
      if ((request.status >= 200 && request.status < 300) || request.status === 412) resolve()
      else reject(new Error("Die Datei konnte nicht hochgeladen werden. Bitte erneut versuchen."))
    }
    request.onerror = () => { cleanup(); reject(new Error("Die Verbindung wurde unterbrochen. Bitte erneut versuchen.")) }
    request.onabort = () => { cleanup(); reject(new Error("Upload abgebrochen.")) }
    request.upload.onprogress = (event) => { if (event.lengthComputable && onProgress) onProgress(event.loaded, event.total) }
    if (signal?.aborted) { reject(new Error("Upload abgebrochen.")); return }
    if (signal) signal.addEventListener("abort", abort, { once: true })
    request.send(file)
  })
}

export function downloadR2File(url, name) {
  if (!/^https:\/\//.test(url || "")) throw new Error("Der Download-Link ist ungültig.")
  const link = document.createElement("a")
  link.href = url
  link.download = name || "datei"
  link.rel = "noopener noreferrer"
  // Content-Disposition on the signed URL initiates a download without buffering large videos in JS.
  document.body.appendChild(link)
  link.click()
  link.remove()
}
